/*
 * Google Tag Manager, gated on ComplyDog consent (spec 25).
 *
 * WHY THIS IS A BRIDGE AND NOT COMPLYDOG'S OWN BLOCKING
 *
 * ComplyDog's documented mechanism is to render a tag inert with
 * type="text/plain" data-cookie-consent="targeting" and release it on consent. Read against the
 * live site (2026-08-21) their release path is, in full:
 *
 *     let node = blockScripts[i]; node && eval(node.innerHTML)
 *
 * Two consequences, both fatal to that approach here:
 *
 *   1. It calls eval(), which a Content-Security-Policy without 'unsafe-eval' refuses. The Allow
 *      button threw an EvalError and did nothing at all. Permitting eval would have meant adding
 *      'unsafe-eval' site-wide - it cannot be scoped to one origin - which hands every script on
 *      the page the ability to turn strings into code.
 *   2. It only ever evaluates innerHTML. Their bundle never reads a src attribute (verified: zero
 *      occurrences). A blocked tag that loads an external file has empty innerHTML, so the release
 *      is eval('') and the script never runs. GTM would have stayed dark even with eval allowed.
 *
 * So this file is loaded normally - no data-cookie-consent attribute, which also means ComplyDog
 * finds no blocked nodes and its eval path never executes. The CSP stays strict, and consent is
 * observed rather than delegated.
 *
 * FAIL CLOSED
 * If ComplyDog is missing, broken, or changes shape, this reports "no consent" and GTM never
 * loads. The failure mode is lost analytics, never tracking somebody who did not agree.
 *
 * WHAT IT WATCHES
 * window.cdogCookies is ComplyDog's state object - {strictlyNecessary, performance, targeting,
 * functional}. It is not a documented API, so the cookie is read as a fallback. Their cookie
 * names are "<campaignId>.TARGETING"; on the free tier campaignId is undefined and the name comes
 * out literally "undefined.TARGETING", which is why the suffix is matched rather than the whole
 * name. If ComplyDog ship a real event one day, replace the polling below with it.
 */
(function () {
    'use strict';

    var CONTAINER = 'GTM-523XKWK';   /* must match Analytics:GtmContainerId - AnalyticsTests asserts it */
    var POLL_MS = 1000;
    var POLL_LIMIT_MS = 5 * 60 * 1000;

    var loaded = false;

    /*
     * Captured NOW, at top-level execution, while document.currentScript still refers to this
     * tag. By the time consent arrives we are inside a timer or an event handler and
     * currentScript is null.
     *
     * Google's CSP guidance: "Tag Manager will then propagate the nonce to any scripts that it
     * adds to the page." So putting our per-request nonce on the gtm.js element below is what
     * lets GTM's own injected inline scripts run under a nonce-based policy.
     *
     * MEASURED OUTCOME (live site, 2026-08-21): the nonce lands on the injected gtm.js correctly
     * - 32 characters, confirmed in the DOM - and GTM still propagated it to NONE of the six
     * inline scripts it added. So this line is worth keeping, but it is not what makes the
     * container work: 'strict-dynamic' is. Do not remove that from the policy.
     */
    var NONCE = (function () {
        try {
            var self = document.currentScript;
            return (self && self.nonce) || '';
        } catch (e) {
            return '';
        }
    })();

    function targetingGranted() {
        /* Authoritative when present: ComplyDog's own in-memory state. */
        try {
            var state = window.cdogCookies;
            if (state && typeof state.targeting === 'boolean') {
                return state.targeting;
            }
        } catch (e) { /* fall through to the cookie */ }

        /* Fallback. Match the suffix, not the whole name - see the campaignId note above. */
        try {
            var jar = document.cookie.split(';');
            for (var i = 0; i < jar.length; i++) {
                var entry = jar[i].trim();
                var eq = entry.indexOf('=');
                if (eq < 0) { continue; }

                var name = entry.slice(0, eq);
                if (name.length < 10 || name.slice(-10) !== '.TARGETING') { continue; }

                var value = decodeURIComponent(entry.slice(eq + 1)).trim().toLowerCase();
                return value === 'true' || value === '1' || value === 'yes' || value === 'accepted';
            }
        } catch (e) { /* fall through */ }

        return false;
    }

    /*
     * Google's loader, from the snippet supplied by the designer. The only change is the two
     * nonce lines, which Google's own CSP guide asks for: both the property and the attribute are
     * set, because the content attribute is what GTM reads and the property is what the browser
     * honours.
     */
    function loadTagManager(i) {
        (function (w, d, s, l, i) {
            w[l] = w[l] || []; w[l].push({
                'gtm.start':
                    new Date().getTime(), event: 'gtm.js'
            }); var f = d.getElementsByTagName(s)[0],
                j = d.createElement(s), dl = l != 'dataLayer' ? '&l=' + l : ''; j.async = true;
            if (NONCE) { j.nonce = NONCE; j.setAttribute('nonce', NONCE); }
            j.src =
                    'https://www.googletagmanager.com/gtm.js?id=' + i + dl; f.parentNode.insertBefore(j, f);
        })(window, document, 'script', 'dataLayer', i);
    }

    function check() {
        if (loaded) { return true; }
        if (!targetingGranted()) { return false; }

        loaded = true;
        loadTagManager(CONTAINER);
        return true;
    }

    /* Already consented on a previous visit - load immediately, no waiting. */
    if (check()) { return; }

    /*
     * ComplyDog dispatches no event we can subscribe to, so the decision has to be observed.
     * The click listener is what actually catches Allow; the interval is a backstop for any path
     * that sets consent without a click, and it gives up after five minutes rather than ticking
     * for the life of the tab. Both are removed the moment consent is seen.
     */
    var started = Date.now();
    var timer = window.setInterval(function () {
        if (check() || Date.now() - started > POLL_LIMIT_MS) {
            window.clearInterval(timer);
        }
    }, POLL_MS);

    document.addEventListener('click', function () {
        /* After the banner's own handler has run, not during it. */
        window.setTimeout(function () {
            if (check()) { window.clearInterval(timer); }
        }, 50);
    }, true);
})();
